import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

export interface DeductionListItemProps {
  className?: string;
  label?: string;
  value: JSX.Element | string;
  important?: boolean;
}
export const DeductionListItem: React.FC<DeductionListItemProps> = ({
  children,
  className,
  label,
  value,
  important,
}) => {
  return (
    <div className={classNames(styles['deduction-list-line'], className)}>
      <div
        className={classNames(styles['deduction-list-label'], {
          [styles['deduction-list-important']]: important,
        })}
      >
        {/* We'll use React.Children here, since it's more likely the label will be composed of multiple items */}
        {children ?? label}
      </div>
      <div
        className={classNames(styles['deduction-list-amount'], {
          [styles['deduction-list-important']]: important,
        })}
      >
        {value}
      </div>
    </div>
  );
};
